import { IAppState } from '../app.state';
 
export const selectCoverages = (state: IAppState) => [...state.coverages.list];